/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "yesterday",
        "0": "lɔꞋɔ",
        "1": "tomorrow",
        "future": {
          "one": "Nǔu lɛ́Ꞌ {0}",
          "other": "Nǔu lɛ́Ꞌ {0}"
        },
        "past": {
          "one": "Ɛ́ gɛ́ mɔ́ lɛ́Ꞌ {0}",
          "other": "Ɛ́ gɛ́ mɔ́ lɛ́Ꞌ {0}"
        }
      },
      "day-narrow": {
        "-1": "yesterday",
        "0": "lɔꞋɔ",
        "1": "tomorrow",
        "future": {
          "one": "Nǔu lɛ́Ꞌ {0}",
          "other": "Nǔu lɛ́Ꞌ {0}"
        },
        "past": {
          "one": "Ɛ́ gɛ́ mɔ́ lɛ́Ꞌ {0}",
          "other": "Ɛ́ gɛ́ mɔ́ lɛ́Ꞌ {0}"
        }
      },
      "day-short": {
        "-1": "yesterday",
        "0": "lɔꞋɔ",
        "1": "tomorrow",
        "future": {
          "one": "Nǔu lɛ́Ꞌ {0}",
          "other": "Nǔu lɛ́Ꞌ {0}"
        },
        "past": {
          "one": "Ɛ́ gɛ́ mɔ́ lɛ́Ꞌ {0}",
          "other": "Ɛ́ gɛ́ mɔ́ lɛ́Ꞌ {0}"
        }
      },
      "hour": {
        "0": "this hour",
        "future": {
          "one": "nǔu háwa {0}",
          "other": "nǔu háwa {0}"
        },
        "past": {
          "one": "ɛ́ gɛ mɔ́ {0} háwa",
          "other": "ɛ́ gɛ mɔ́ {0} háwa"
        }
      },
      "hour-narrow": {
        "0": "this hour",
        "future": {
          "one": "nǔu háwa {0}",
          "other": "nǔu háwa {0}"
        },
        "past": {
          "one": "ɛ́ gɛ mɔ́ {0} háwa",
          "other": "ɛ́ gɛ mɔ́ {0} háwa"
        }
      },
      "hour-short": {
        "0": "this hour",
        "future": {
          "one": "nǔu háwa {0}",
          "other": "nǔu háwa {0}"
        },
        "past": {
          "one": "ɛ́ gɛ mɔ́ {0} háwa",
          "other": "ɛ́ gɛ mɔ́ {0} háwa"
        }
      },
      "minute": {
        "0": "this minute",
        "future": {
          "one": "nǔu {0} minút",
          "other": "nǔu {0} minút"
        },
        "past": {
          "one": "ɛ́ gɛ́ mɔ́ minút {0}",
          "other": "ɛ́ gɛ́ mɔ́ minút {0}"
        }
      },
      "minute-narrow": {
        "0": "this minute",
        "future": {
          "one": "nǔu {0} minút",
          "other": "nǔu {0} minút"
        },
        "past": {
          "one": "ɛ́ gɛ́ mɔ́ minút {0}",
          "other": "ɛ́ gɛ́ mɔ́ minút {0}"
        }
      },
      "minute-short": {
        "0": "this minute",
        "future": {
          "one": "nǔu {0} minút",
          "other": "nǔu {0} minút"
        },
        "past": {
          "one": "ɛ́ gɛ́ mɔ́ minút {0}",
          "other": "ɛ́ gɛ́ mɔ́ minút {0}"
        }
      },
      "month": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "one": "Nǔu {0} saŋ",
          "other": "Nǔu {0} saŋ"
        },
        "past": {
          "one": "ɛ́ gɛ́ mɔ́ pɛsaŋ {0}",
          "other": "ɛ́ gɛ́ mɔ́ pɛsaŋ {0}"
        }
      },
      "month-narrow": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "one": "Nǔu {0} saŋ",
          "other": "Nǔu {0} saŋ"
        },
        "past": {
          "one": "ɛ́ gɛ́ mɔ́ pɛsaŋ {0}",
          "other": "ɛ́ gɛ́ mɔ́ pɛsaŋ {0}"
        }
      },
      "month-short": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "one": "Nǔu {0} saŋ",
          "other": "Nǔu {0} saŋ"
        },
        "past": {
          "one": "ɛ́ gɛ́ mɔ́ pɛsaŋ {0}",
          "other": "ɛ́ gɛ́ mɔ́ pɛsaŋ {0}"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-narrow": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "second-narrow": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "second-short": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "week": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "one": "Nǔu ŋgap-mbi {0}",
          "other": "Nǔu ŋgap-mbi {0}"
        },
        "past": {
          "one": "Ɛ́ gɛ́ mɔ {0} ŋgap-mbi",
          "other": "Ɛ́ gɛ́ mɔ {0} ŋgap-mbi"
        }
      },
      "week-narrow": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "one": "Nǔu ŋgap-mbi {0}",
          "other": "Nǔu ŋgap-mbi {0}"
        },
        "past": {
          "one": "Ɛ́ gɛ́ mɔ {0} ŋgap-mbi",
          "other": "Ɛ́ gɛ́ mɔ {0} ŋgap-mbi"
        }
      },
      "week-short": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "one": "Nǔu ŋgap-mbi {0}",
          "other": "Nǔu ŋgap-mbi {0}"
        },
        "past": {
          "one": "Ɛ́ gɛ́ mɔ {0} ŋgap-mbi",
          "other": "Ɛ́ gɛ́ mɔ {0} ŋgap-mbi"
        }
      },
      "year": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "one": "Nǔu ŋguꞋ {0}",
          "other": "Nǔu ŋguꞋ {0}"
        },
        "past": {
          "one": "Ɛ́gɛ́ mɔ́ ŋguꞋ {0}",
          "other": "Ɛ́gɛ́ mɔ́ ŋguꞋ {0}"
        }
      },
      "year-narrow": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "one": "Nǔu ŋguꞋ {0}",
          "other": "Nǔu ŋguꞋ {0}"
        },
        "past": {
          "one": "Ɛ́gɛ́ mɔ́ ŋguꞋ {0}",
          "other": "Ɛ́gɛ́ mɔ́ ŋguꞋ {0}"
        }
      },
      "year-short": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "one": "Nǔu ŋguꞋ {0}",
          "other": "Nǔu ŋguꞋ {0}"
        },
        "past": {
          "one": "Ɛ́gɛ́ mɔ́ ŋguꞋ {0}",
          "other": "Ɛ́gɛ́ mɔ́ ŋguꞋ {0}"
        }
      }
    },
    "locale": "jgo"
  });
}